
















import { NextQuery } from '@empathy/search-types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class NextQueryResults extends Vue {
  @Prop({ required: true })
  private item: NextQuery;

  get titleMsgOptions() {
    return { numFound: this.item.numFound, query: this.item.query };
  }
}
